import { authService } from "services";
import { applyUserLocale } from "../i18n";


export const login = (username, password) => async (dispatch) => {
	dispatch({
		type: 'LOADING'
	});

	let response = await authService.login(username, password);
	// console.log(response);

	if (response.ok) {
		applyUserLocale(response.user);
		dispatch({
			type: 'LOGIN_SUCCESS',
			token: response.token,
			user: response.user
		});
	}
	else {
		dispatch({
			type: 'AUTH_ERROR',
			errors: response.errors,
			error_message: response.error_message
		});
	}
}

export const register = (user) => async dispatch => {
	dispatch({
		type: 'LOADING'
	});

	let response = await authService.register(user);
	// console.log(response);

	if (response.ok) {
		applyUserLocale(response.user);
		dispatch({
			type: 'REGISTER',
			token: response.token,
			user: response.user
		});
	}
	else {
		dispatch({
			type: 'AUTH_ERROR',
			errors: response.errors,
			error_message: response.error_message
		});
	}
}

export const update = () => async (dispatch) => {
	try {
		let user = await authService.getCurrent();
		// console.log(user);
		await authService.setUser(user);
		applyUserLocale(user);

		dispatch({
			type: 'UPDATE_USER',
			user,
			token: authService.token
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
	}
}

export const sso = () => async (dispatch) => {
	try {
		let user = await authService.initializeAuthService();
		if (user) {
			applyUserLocale(user);
			dispatch({
				type: 'SSO',
				user,
				token: authService.token,
			});
			return Promise.resolve(user);
		}
		return Promise.reject("Error en SSO");
	}
	catch (error) {
		return Promise.reject(error);
	}
}